// extracted by mini-css-extract-plugin
export default {"loading":"Chat_loading__iioU+"};